import React from "react";
import { useTheme } from "../ThemeContext";

export default function ThemeToggle() {
  const { toggleTheme, isDark } = useTheme();
  return (
    <button onClick={toggleTheme}
      className="w-10 h-10 rounded-full flex items-center justify-center transition-all"
      style={{ background: isDark ? "#374151" : "#F3F4F6" }}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <span className="text-lg">{isDark ? "☀️" : "🌙"}</span>
    </button>
  );
}
